import { Collection } from '../../shared/constants';
import { getAllDocsByClientId, getAllDocsByParkId, getDocById, updateDoc } from './collectionBaseWorker';

export const getAllAccreditedByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByParkId({ collection: Collection.ACCREDITEDS, estacionamentoId: estacionamentoId })
}

export const getAllAccreditedsByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.ACCREDITEDS, clienteId: clienteId })
}

export const getAccreditedById = async ({ id }) => {
    return getDocById({ collection: Collection.ACCREDITEDS, id: id })
}

export const getAccreditedByPlateAndParkId = async ({ plate, parkId }) => {
    const accrediteds = await getAllAccreditedByParkId(parkId)
    const accredited = accrediteds.filter(e => e.veiculos.map(e => e.placa).indexOf(plate) !== -1)[0]
    if (accredited) {
        accredited.currentVehicle = accredited.veiculos.filter(e => e.placa === plate)[0]
        return accredited
    }
    return null
}

export const getAccreditedsByPlateAndClientId = async ({ plate, clienteId }) => {
    const accrediteds = await getAllAccreditedsByClientId({ clienteId: clienteId })
    return accrediteds.filter(e => e.veiculos.map(e => e.placa).indexOf(plate) !== -1)
}

export const getAccreditedVehicleByPlateAndParkId = async ({ plate, parkId }) => {
    const accrediteds = await getAllAccreditedByParkId({ estacionamentoId: parkId })
    return accrediteds.map(e => e.veiculos.map(e => e.placa)).flatMap(e => e).filter(e => e.placa === plate)[0]
}

export const updateAccreditedById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.ACCREDITEDS, id: id, data: data })
}